module.exports = __webpack_public_path__ + "static/media/basicos.1c7aae6a.svg";